import { Component, Input } from '@angular/core';
import { DynamicReviewsExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

const MAX_STARS = 5;
const HALF_STAR = 0.5;

type StarFill = 0 | 0.5 | 1;

/**
 * Star row shared by the Dynamic Reviews and checkout upsell editors. Presentational only — the
 * storefront draws its own stars as an SVG inside the Shopify extension.
 */
@Component({
  selector: 'pdq-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  standalone: false,
})
export class StarRatingComponent {
  @Input() set rating(value: number) {
    this.stars = Array(MAX_STARS)
      .fill(0)
      .map((_, index) => (index < Math.floor(value) ? 1 : index < value ? HALF_STAR : 0));
  }

  @Input() set color(value: string | null | undefined) {
    this.starColor = value || DynamicReviewsExtension.DEFAULT_STAR_COLOR;
  }

  @Input() reviewCount: number | null = null;

  @Input() compact = false;

  stars: StarFill[] = [];
  starColor: string = DynamicReviewsExtension.DEFAULT_STAR_COLOR;
}
